import React from 'react';
import api from 'controllers/raymanAPI';
import Singletons from 'controllers/Singletons';

function map(item)
{
    return {...item, id: item.fieldID}
}

async function getData(templateID)
{
    let indexed = {};
    let procedureFields = [];
    let stepFields = [];
    let response = await api.procedures.templates.fields.getAll(templateID);
    let data = await response.json();
    data = data.map((item)=>map(item));
    data.forEach(item => {
        indexed[item.fieldID] = item;
        if(item.isStepField) stepFields.push(item);
        else procedureFields.push(item);
    });
    
    return {array: data, indexed: indexed, procedureFields: procedureFields, stepFields: stepFields};
}

const TemplateFieldsCtx = React.createContext({
    loading: true, 
    data: {
        array: [], 
        procedureFields: [],
        stepFields: [],
        indexed: {}
    }, 
    funcs: {
        create: () => {},
        update: () => {},
        delete: () => {},
    }
});

function TemplateFieldsCtxProvider({templateID, ...props})
{

    const [loading, setLoading] = React.useState(true);
    const [data, setData] = React.useState({array: [], indexed: {}, procedureFields: [], stepFields: []});

    React.useEffect(() => {
        if(!templateID) return;
        getData(templateID).then(values => {
            setData(values);
            setLoading(false);
        });
    }, [templateID]);
    

    const internalRefresh = React.useCallback(() => {
        getData(templateID).then(values => {
            setData(values);
            setLoading(false);
        });
    }, [templateID]);

    const internalUpdate = React.useCallback((fieldID, stepData) => {
        let tmp = {...data};
        if(stepData.order && stepData.order !== tmp.indexed[fieldID].order) internalRefresh();
        else {
            Object.keys(stepData).forEach((key) => {
                if(key === "fieldID") return;
                tmp.indexed[fieldID][key] = stepData[key];
            })
            setData(tmp);
        }
    }, [data, internalRefresh]);

    const internalAdd = React.useCallback(async (fieldID, item) => {

        if(data.indexed[fieldID] !== undefined) return internalUpdate(fieldID, item);
        let tmp = {...data};
        item = map(item);
        let index = tmp.array.push(item);
        tmp.indexed[item.id] = tmp.array[index-1];
        if(item.isStepField) tmp.stepFields.push(item);
        else tmp.procedureFields.push(item);
        setData(tmp);

    }, [internalUpdate, data]);

    

    const internalDelete = React.useCallback((fieldID) => {
        let tmp = {...data};
        let item = tmp.indexed[fieldID];

        // remove from array
        let index = tmp.array.indexOf(item);
        if(index > -1) tmp.array.splice(index,1);

        if(item.isStepField)
        {
            index = tmp.stepFields.indexOf(item);
            if(index > -1) tmp.stepFields.splice(index,1);
        }
        else
        {
            index = tmp.procedureFields.indexOf(item);
            if(index > -1) tmp.procedureFields.splice(index,1);
        }

        delete tmp.indexed[fieldID];
        setData(tmp);
    }, [data]);    


    const create = React.useCallback(async (data) => {
        if(!templateID) return;
        let result = await api.procedures.templates.fields.post(templateID, data);
        if(result.ok)
        {
            let field = await result.json();
            await internalAdd(field.fieldID, field);
            return field;
        }
    }, [templateID, internalAdd]);

    const update = React.useCallback(async (fieldID, data) => {
        if(!templateID) return;
        if(data.dataType && typeof(data.dataType) === "object") data.dataType = data.dataType.typeID;
        let result = await api.procedures.templates.fields.updateSingle(templateID, fieldID, data);
        if(result.ok) internalUpdate(fieldID, await result.json());

    }, [templateID, internalUpdate]);

    const remove = React.useCallback(async (fieldID) => {
        if(!templateID) return;
        let result = await api.procedures.templates.fields.deleteSingle(templateID, fieldID);
        if(result.ok) internalDelete(fieldID);
    }, [templateID, internalDelete]);

    React.useEffect( function handleNotifications() {

        const handleCreate = (message) => internalAdd(message.fieldID, message);
        // const handleEnable = (message) => internalUpdate(message.fieldID, {disabled: false});
        // const handleDisable = (message) => internalUpdate(message.fieldID, {disabled: true});
        const handleUpdate = (message) => internalUpdate(message.fieldID, message);
        const handleDelete = (message) => internalDelete(message.fieldID, message);

        // Singletons.NotificationsSocket.on('procedures.templates.fields.created', handleCreate);
        // // Singletons.NotificationsSocket.on('procedures.templates.fields.disabled', handleDisable);
        // // Singletons.NotificationsSocket.on('procedures.templates.fields.enabled', handleEnable);
        // Singletons.NotificationsSocket.on('procedures.templates.fields.updated', handleUpdate);
        // Singletons.NotificationsSocket.on('procedures.templates.fields.deleted', handleDelete);

        return () => {
            // Singletons.NotificationsSocket.off('procedures.templates.fields.created', handleCreate);
            // // Singletons.NotificationsSocket.off('procedures.templates.fields.disabled', handleDisable);
            // // Singletons.NotificationsSocket.off('procedures.templates.fields.enabled', handleEnable);
            // Singletons.NotificationsSocket.off('procedures.templates.fields.updated', handleUpdate);
            // Singletons.NotificationsSocket.off('procedures.templates.fields.deleted', handleDelete);
        }

    }, [internalAdd, internalUpdate, internalDelete]);

    return <TemplateFieldsCtx.Provider value={{loading: loading, data: {...data}, funcs: {create: create, update: update, delete: remove}}} >
        {props.children}
        </TemplateFieldsCtx.Provider>
}

export {TemplateFieldsCtx, TemplateFieldsCtxProvider};